import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APP, ONBOARDING_ROUTES } from '../../../stores/session-status';
import eventsLogo from '../../../images/events-logo.svg';
import brandlivePlatformIcon from '../../../images/brandlive-platform-icon.png';
import customDestinationLogo from '../../../images/custom-destination-logo.svg';
import TellyChannelLogo from '../../../images/app-store-icon.png';
import * as SessionActions from '../../../stores/actions/session';
import { setShowDeprecationWarning } from '../../../stores/actions/user-interface';
import { GreenroomState as GS } from '../../../stores/types/types';
import LoadingSpinner from '../../general-components/loading-spinner';
import Colors from '../../../utils/colors';
import BrandLiveLogo from '../../general-components/brandlive-logo';

export default function ProducerSelectApp() {
	const showroomsTokens = useSelector((s: GS) => s.SessionReducer.showroomsTokens);
	const isEventsProducer = useSelector((s: GS) => s.SessionReducer.isEventsProducer);
	const isEventsLegacyProducer = useSelector((s: GS) => s.SessionReducer.isEventsLegacyProducer);
	const isStandaloneProducer = useSelector((s: GS) => s.SessionReducer.isStandaloneProducer);
	const loadingProducerApps = useSelector((s: GS) => s.SessionReducer.loadingProducerApps);
	const loadingIsEventsProducer = useSelector((s: GS) => s.SessionReducer.loadingIsEventsProducer);
	const emailEntered = useSelector((s: GS) => s.SessionReducer.emailEntered);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(SessionActions.checkAppsEmailIsAProducerFor(emailEntered));
	}, [dispatch, emailEntered]);

	function appButtonClicked(app: string) {
		if (app === APP.GREENROOM) {
			dispatch(setShowDeprecationWarning(true));
		}

		dispatch(SessionActions.setSelectedApp(app));
		switch (app) {
			case APP.EVENTS_LEGACY:
			case APP.EVENTS:
			case APP.GREENROOM:
				dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRODUCER_LOGIN));
				break;
			case APP.SHOWROOMS:
				if (showroomsTokens) {
					dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRODUCER_SELECT_MEETING));
				} else {
					dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRODUCER_LOGIN));
				}
				break;
			default:
				break;
		}
	}

	useEffect(() => {
		if (emailEntered && !loadingProducerApps) {
			const appsAvailable = [];
			if (isStandaloneProducer) appsAvailable.push('isStandAloneProducer');
			if (isEventsProducer) appsAvailable.push('isEventsProducer');
			if (isEventsLegacyProducer) appsAvailable.push('isEventsLegacyProducer');
			if (appsAvailable.length === 1) {
				if (appsAvailable[0] === 'isEventsProducer') { appButtonClicked(APP.EVENTS); }
				if (appsAvailable[0] === 'isEventsLegacyProducer') { appButtonClicked(APP.EVENTS_LEGACY); }
				if (appsAvailable[0] === 'isStandAloneProducer') { appButtonClicked(APP.GREENROOM); }
			}
		}
	}, [
		appButtonClicked,
		emailEntered,
		isEventsLegacyProducer,
		isEventsProducer,
		isStandaloneProducer,
		loadingProducerApps,
	]);

	function backButtonClicked() {
		dispatch(SessionActions.setOnboardingRoute(ONBOARDING_ROUTES.PRODUCER_ENTER_EMAIL));
	}

	return (
		<div className="panel producer sign-in select-app">
			<div className="producer-logo-title">
				<img src={TellyChannelLogo} style={{ width: '48px', marginBottom: '15px' }} alt={'Connected'} />
				<div className="title-container">
					<span className="title green">Greenroom	<span className="title">Producer</span></span>
				</div>
			</div>

			{(loadingProducerApps || loadingIsEventsProducer)
				? <div className="loading-container">
					<LoadingSpinner
						height={100}
						width={100}
						color={Colors.red}
					/>
				</div>
				: <div className="apps-container">
					{isEventsProducer
						&& <button className="app-button" onClick={() => appButtonClicked(APP.EVENTS)}>
							<img src={brandlivePlatformIcon} className="logo events" alt={'Connected'} />
							<span className="logo brandlive">
								<BrandLiveLogo width={100} height={30} />
							</span>
						</button>
					}

					{isEventsLegacyProducer
						&& <button className="app-button" onClick={() => appButtonClicked(APP.EVENTS_LEGACY)}>
							<img src={eventsLogo} className="logo events" alt={'Connected'} />
							<span className="title events">Events Legacy</span>
						</button>
					}

					{isStandaloneProducer
						&& <button className="app-button" onClick={() => appButtonClicked(APP.GREENROOM)}>
							<img src={customDestinationLogo} className="logo custom-destination" alt={'Connected'} />
							<span className="title custom-destination">Custom Destination</span>
						</button>
					}

					{!isEventsProducer && !isEventsLegacyProducer && !isStandaloneProducer
						&& <span className="no-accounts">No producer accounts were found for the email entered in any of the Brandlive apps</span>
					}
				</div>
			}
			<div className="back-button">
				<span><span onClick={backButtonClicked} className="clickable">Back to enter email</span></span>
			</div>
		</div>

	);
}
